const {phoenixAjaxNonce, phoenixAjaxUrl} = window;

export default (
    initialCurrentStepIndex = 0,
) => ({

    steps: [],
    currentStepIndex: initialCurrentStepIndex,
    loading: false,
    id: '',
    name: '',
    email: '',
    password: '',
    locale: '',
    gdpr: '',
    errors: {
        id: [],
        name: [],
        email: [],
        password: [],
        locale: [],
        gdpr: [],
    },

    init() {
        this.steps = this.$refs.steps.children;
    },

    nextStep() {
        if (this.currentStepIndex === this.steps.length - 1) {
            return;
        }
        this.currentStepIndex++;
    },

    previousStep() {
        if (this.currentStepIndex === 0) {
            return;
        }
        this.currentStepIndex--;
    },

    validate(fields) {
        const config = {
            action: 'phoenix_validate_registration_form',
            security: phoenixAjaxNonce,
        };
        const data = {...config, fields: fields};

        jQuery.ajax({
            type: 'POST',
            url: phoenixAjaxUrl,
            data: data,
            beforeSend: () => {
                this.loading = true;
            },
            complete: (jqXHR, textStatus) => {
                this.loading = false;
            },
            success: (data, textStatus, jqXHR) => {
                console.log(data);
                this.$root.dispatchEvent(new CustomEvent('phoenix-register-form-validation', {
                    detail: {
                        errors: JSON.parse(data).errors,
                        isValid: JSON.parse(data).isValid,
                    },
                }));
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.log(jqXHR);
                console.log(textStatus);
                console.log(errorThrown);
            },
        });
    },

    handleValidationResponse(event) {
        const {errors, isValid, session} = event.detail;
        this.errors = errors;

        if (isValid) {
            this.nextStep();
        } else {

            // Full validation only happens on last page.
            if (this.errors.id.length) {
                this.currentStepIndex = 0;
            } else if (this.errors.email.length || this.errors.password.length || this.errors.gdpr.length) {
                this.currentStepIndex = 1;
            }
        }
    },
});